// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImportCalendar-errorMessage-OqcBa {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.ImportCalendar-space1-JXzOR {
	margin-bottom: 6px !important;
}
.ImportCalendar-space2-F4WdQ {
	margin-bottom: 12px !important;
}
.ImportCalendar-space3-LNrRg {
	margin-bottom: 18px !important;
}
.ImportCalendar-space4-akWWD {
	margin-bottom: 24px !important;
}
.ImportCalendar-space5-v0Utg {
	margin-bottom: 30px !important;
}
.ImportCalendar-space6-s1yYV {
	margin-bottom: 36px !important;
}
.ImportCalendar-space7-v3sc7 {
	margin-bottom: 42px !important;
}
.ImportCalendar-spaceTop8-tfX6N {
	margin-bottom: 48px !important;
}
.ImportCalendar-spaceTop1-zYOhW {
	margin-top: 6px !important;
}
.ImportCalendar-spaceTop2-jYZ4D {
	margin-top: 12px !important;
}
.ImportCalendar-spaceTop3-HNuCD {
	margin-top: 18px !important;
}
.ImportCalendar-spaceTop4-z5_B1 {
	margin-top: 24px !important;
}
.ImportCalendar-spaceTop5-qLh1Z {
	margin-top: 30px !important;
}
.ImportCalendar-spaceTop6-LITwC {
	margin-top: 36px !important;
}
.ImportCalendar-spaceTop7-fzn4B {
	margin-top: 42px !important;
}
.ImportCalendar-spaceTop8-tfX6N {
	margin-top: 48px !important;
}
.ImportCalendar-noMargin-H8iXk {
	margin: 0px !important;
}
.ImportCalendar-padding1-PIRv1 {
	padding-bottom: 6px !important;
}
.ImportCalendar-padding2-DsJpK {
	padding-bottom: 12px !important;
}
.ImportCalendar-padding3-iPHrC {
	padding-bottom: 18px !important;
}
.ImportCalendar-padding4-wMq65 {
	padding-bottom: 24px !important;
}
.ImportCalendar-padding5-dETdU {
	padding-bottom: 30px !important;
}
.ImportCalendar-padding6-lH2ID {
	padding-bottom: 36px !important;
}
.ImportCalendar-padding7-IdDFD {
	padding-bottom: 42px !important;
}
.ImportCalendar-paddingTop1-jAJVd {
	padding-top: 6px !important;
}
.ImportCalendar-paddingTop2-pR9to {
	padding-top: 12px !important;
}
.ImportCalendar-paddingTop3-wY3iV {
	padding-top: 18px !important;
}
.ImportCalendar-paddingTop4-Q30kq {
	padding-top: 24px !important;
}
.ImportCalendar-paddingTop5-pbr0t {
	padding-top: 30px !important;
}
.ImportCalendar-paddingTop6-Mrgfw {
	padding-top: 36px !important;
}
.ImportCalendar-paddingTop7-p8Gan {
	padding-top: 42px !important;
}
.ImportCalendar-noPadding-pf46o {
	padding: 0px !important;
}
.ImportCalendar-textBold-KdhEf {
	font-weight: 500 !important;
}
.ImportCalendar-textBolder-_pYOr {
	font-weight: 700 !important;
}
.ImportCalendar-textNormal-NSevz {
	font-weight: normal !important;
}
.ImportCalendar-spaceBottom20-Ti6Cp {
	margin-bottom: 20px;
}
.ImportCalendar-spaceBottom10-t3n3z {
	margin-bottom: 10px;
}
.ImportCalendar-marginNone-OUYqS {
	margin: 0;
}
.ImportCalendar-spaceBottom15-eTQ2g {
	margin-bottom: 15px;
}
.ImportCalendar-marginTopNone-HMSvN {
	margin-top: 0;
}
.ImportCalendar-spaceTop11-xvKY2 {
	margin-top: 11px;
}
.ImportCalendar-spaceTop21-cXdRi {
	margin-top: 21px;
}
.ImportCalendar-spaceTop20-pBDzS {
	margin-top: 20px;
}
.ImportCalendar-spaceTop10-AEbMq {
	margin-top: 10px;
}
/*New Design Text Colors */
.ImportCalendar-textDarkBlue-L8fSb {
	color: rgb(20, 39, 94) !important;
}
.ImportCalendar-textLightBlue-bv5iU {
	color: rgb(57, 87, 106) !important;
}
.ImportCalendar-textLightSandleGreen-MY3xD {
	color: rgb(76, 86, 41) !important;
}
.ImportCalendar-textLightBrown-wyzqF {
	color: rgb(115, 79, 33) !important;
}
.ImportCalendar-textMediumMaroon-EApXj {
	color: rgb(87, 37, 51) !important;
}
.ImportCalendar-textBrown-aHADp {
	color: rgb(160, 47, 24) !important;
}
.ImportCalendar-textMaroon-L6uqH {
	color: rgb(155, 49, 67) !important;
}
.ImportCalendar-textDarkBrown-Jr8Aq {
	color: rgb(83, 18, 16) !important;
}
.ImportCalendar-textMediumBrown-zSQWQ {
	color: rgb(142, 28, 10) !important;
}
.ImportCalendar-textSkyBlue-HkrnM {
	color: rgb(37, 117, 141) !important;
}
.ImportCalendar-textGray-MxQq8 {
	color: rgb(77, 65, 51) !important;
}
.ImportCalendar-logInModalBody-yqvio {
	padding: 0px;
}
.ImportCalendar-modalHeading-PodBE {
	font-size: 16px;
	padding: 15px;
}
.ImportCalendar-panelHeader-DaDMv {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	border-bottom: 1px solid var(--primary-border);
	margin: 0px;
}
.ImportCalendar-panelBody-uGzW6 {
	margin: 0;
	padding: 20px;
	position: relative;
}
.ImportCalendar-labelText-Q8awM {
	font-size: 14px;
	font-weight: bold;
}
.ImportCalendar-formControlInput-cHGyP {
	display: block;
	padding: 8px 10px !important;
	width: 100%;
}
.ImportCalendar-formGroup-lqexO {
	margin-bottom: 6px;
}
/*************************Panel Styles End******************************************/
a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}
a:hover {
	cursor: pointer;
	text-decoration: none;
}
.ImportCalendar-btnRight-oVOZR {
	margin-right: 10px;
}
.ImportCalendar-introText-OhvVM {
	font-size: 14px;
	margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/ListPlaceStep1/SyncCalendar/ImportCalendar/ImportCalendar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;CACC,YAAY;AACb;AAEA;CACC,eAAe;CACf,aAAa;AACd;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,8CAA8C;CAC9C,WAAW;AACZ;AAEA;CACC,SAAS;CACT,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AAEA;CACC,cAAc;CACd,4BAA4B;CAC5B,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA,oFAAoF;AACpF;CACC,qCAAqC;CACrC,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,qBAAqB;AACtB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../utils.css';\n@import '../../../helpers.css';\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n.modalHeading {\n\tfont-size: 16px;\n\tpadding: 15px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tmargin: 0px;\n}\n\n.panelBody {\n\tmargin: 0;\n\tpadding: 20px;\n\tposition: relative;\n}\n\n.labelText {\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n\n.formControlInput {\n\tdisplay: block;\n\tpadding: 8px 10px !important;\n\twidth: 100%;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n/*************************Panel Styles End******************************************/\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\n.btnRight {\n\tmargin-right: 10px;\n}\n\n.introText {\n\tfont-size: 14px;\n\tmargin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ImportCalendar-errorMessage-OqcBa`,
	"space1": `ImportCalendar-space1-JXzOR`,
	"space2": `ImportCalendar-space2-F4WdQ`,
	"space3": `ImportCalendar-space3-LNrRg`,
	"space4": `ImportCalendar-space4-akWWD`,
	"space5": `ImportCalendar-space5-v0Utg`,
	"space6": `ImportCalendar-space6-s1yYV`,
	"space7": `ImportCalendar-space7-v3sc7`,
	"spaceTop8": `ImportCalendar-spaceTop8-tfX6N`,
	"spaceTop1": `ImportCalendar-spaceTop1-zYOhW`,
	"spaceTop2": `ImportCalendar-spaceTop2-jYZ4D`,
	"spaceTop3": `ImportCalendar-spaceTop3-HNuCD`,
	"spaceTop4": `ImportCalendar-spaceTop4-z5_B1`,
	"spaceTop5": `ImportCalendar-spaceTop5-qLh1Z`,
	"spaceTop6": `ImportCalendar-spaceTop6-LITwC`,
	"spaceTop7": `ImportCalendar-spaceTop7-fzn4B`,
	"noMargin": `ImportCalendar-noMargin-H8iXk`,
	"padding1": `ImportCalendar-padding1-PIRv1`,
	"padding2": `ImportCalendar-padding2-DsJpK`,
	"padding3": `ImportCalendar-padding3-iPHrC`,
	"padding4": `ImportCalendar-padding4-wMq65`,
	"padding5": `ImportCalendar-padding5-dETdU`,
	"padding6": `ImportCalendar-padding6-lH2ID`,
	"padding7": `ImportCalendar-padding7-IdDFD`,
	"paddingTop1": `ImportCalendar-paddingTop1-jAJVd`,
	"paddingTop2": `ImportCalendar-paddingTop2-pR9to`,
	"paddingTop3": `ImportCalendar-paddingTop3-wY3iV`,
	"paddingTop4": `ImportCalendar-paddingTop4-Q30kq`,
	"paddingTop5": `ImportCalendar-paddingTop5-pbr0t`,
	"paddingTop6": `ImportCalendar-paddingTop6-Mrgfw`,
	"paddingTop7": `ImportCalendar-paddingTop7-p8Gan`,
	"noPadding": `ImportCalendar-noPadding-pf46o`,
	"textBold": `ImportCalendar-textBold-KdhEf`,
	"textBolder": `ImportCalendar-textBolder-_pYOr`,
	"textNormal": `ImportCalendar-textNormal-NSevz`,
	"spaceBottom20": `ImportCalendar-spaceBottom20-Ti6Cp`,
	"spaceBottom10": `ImportCalendar-spaceBottom10-t3n3z`,
	"marginNone": `ImportCalendar-marginNone-OUYqS`,
	"spaceBottom15": `ImportCalendar-spaceBottom15-eTQ2g`,
	"marginTopNone": `ImportCalendar-marginTopNone-HMSvN`,
	"spaceTop11": `ImportCalendar-spaceTop11-xvKY2`,
	"spaceTop21": `ImportCalendar-spaceTop21-cXdRi`,
	"spaceTop20": `ImportCalendar-spaceTop20-pBDzS`,
	"spaceTop10": `ImportCalendar-spaceTop10-AEbMq`,
	"textDarkBlue": `ImportCalendar-textDarkBlue-L8fSb`,
	"textLightBlue": `ImportCalendar-textLightBlue-bv5iU`,
	"textLightSandleGreen": `ImportCalendar-textLightSandleGreen-MY3xD`,
	"textLightBrown": `ImportCalendar-textLightBrown-wyzqF`,
	"textMediumMaroon": `ImportCalendar-textMediumMaroon-EApXj`,
	"textBrown": `ImportCalendar-textBrown-aHADp`,
	"textMaroon": `ImportCalendar-textMaroon-L6uqH`,
	"textDarkBrown": `ImportCalendar-textDarkBrown-Jr8Aq`,
	"textMediumBrown": `ImportCalendar-textMediumBrown-zSQWQ`,
	"textSkyBlue": `ImportCalendar-textSkyBlue-HkrnM`,
	"textGray": `ImportCalendar-textGray-MxQq8`,
	"logInModalBody": `ImportCalendar-logInModalBody-yqvio`,
	"modalHeading": `ImportCalendar-modalHeading-PodBE`,
	"panelHeader": `ImportCalendar-panelHeader-DaDMv`,
	"panelBody": `ImportCalendar-panelBody-uGzW6`,
	"labelText": `ImportCalendar-labelText-Q8awM`,
	"formControlInput": `ImportCalendar-formControlInput-cHGyP`,
	"formGroup": `ImportCalendar-formGroup-lqexO`,
	"btnRight": `ImportCalendar-btnRight-oVOZR`,
	"introText": `ImportCalendar-introText-OhvVM`
};
module.exports = ___CSS_LOADER_EXPORT___;
